import Vue from "vue";

import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";

import CommaInput from "@/components/CommaInput.vue";
import MaxLengthInput from "@/components/MaxLengthInput.vue";
import MaxLengthTextarea from "@/components/MaxLengthTextarea.vue";
import MaxLengthEditor from "@/components/MaxLengthEditor.vue";
import HyphenInput from "@/components/HyphenInput.vue";
import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";
import TableCustom from "@/components/TableCustom.vue";

Vue.component("FieldSelectModule", FieldSelectModule);
Vue.component("FileUploadModule", FileUploadModule);
Vue.component("PhotoUploadGridModule", PhotoUploadGridModule);
Vue.component("DateSelector", DateSelector);
Vue.component("TimeSelector", TimeSelector);

Vue.component("CommaInput", CommaInput);
Vue.component("MlInput", MaxLengthInput);
Vue.component("MlTextarea", MaxLengthTextarea);
Vue.component("MlEditor", MaxLengthEditor);
Vue.component("HyphenInput", HyphenInput);
Vue.component("RadioTypeCheck", RadioTypeCheck);
Vue.component("TableCustom", TableCustom);
